import { createValidators } from '@wr/shared';
// Only the lists are bundled: the rest of the file (roles, rules) stays on the server.
import { lists } from '../../../config/portal.json';

/**
 * Business lists of config/portal.json (brief section 12), built into the app
 * so the forms work offline. The server validates the same file at start-up
 * and checks every change again.
 */
export const LISTS = lists;

export const { validateContact, validateLeadCreation, contactPushBlockers } =
  createValidators(lists);

/** "WR-4 Metals", as the forms show an operating market. */
export function marketLabel(code: string): string {
  const market = lists.markets.find((m) => m.code === code);
  return market ? `${market.code} ${market.name}` : code;
}

export function optionLabel(
  options: readonly { value: string; label: string }[],
  value: string | null | undefined,
): string {
  return options.find((o) => o.value === value)?.label ?? '';
}
